<style lang="less" rel="stylesheet/less" scoped>
    .wrapper{
        background:#ECEFF1;
        padding:18px 0;
        box-sizing:border-box;
    }

    .box{
        background:#fff;
        .row{
            overflow:hidden;
            padding:15px 0;
            margin-left:20px;
            border-bottom:1px solid #eee;
            .label{
                float:left;
                width:30%;
                box-sizing:border-box;
                color:#999;
                &.special{
                    padding-top:20px;
                }
            }
            .value{
                float:right;
                width:70%;
                text-align:right;
                box-sizing:border-box;
                padding-right:40px;
                position:relative;

                &:before,&:after{
                    content:'';
                    display:block;
                    height:10px;
                    width:1px;
                    background:#333;
                    position:absolute;
                    top:40%;
                    right:20px;
                    transform-origin: bottom center;
                    transform:translateY(-50%) rotate(-20deg);
                }
                &:after{
                    transform:translateY(-50%) rotate(200deg);
                }
            }
        }
        .avatar{
            width:56px;
            height:56px;
            background:#ccc;
            display:inline-block;
            border-radius:99px;
        }
    }

</style>
<template>
    <div class="wrapper" :style="{minHeight:minHeight+'px'}">
        <div class="box">
            <div class="row">
                <div class="label special">
                    修改头像
                </div>
                <div class="value">
                    <div class="avatar" src="" alt=""/>
                </div>
            </div>
            <div class="row">
                <div class="label">
                    昵称
                </div>
                <div class="value">
                    afdasdfasdfadsf
                </div>
            </div>
            <div class="row">
                <div class="label">
                    手机
                </div>
                <div class="value">
                    1111111111111111123
                </div>
            </div>
        </div>
        <BottomBar :index="2"></BottomBar>
    </div>
</template>
<script type="text/ecmascript-6">
    import Store from '../lib/store';
    import api from '../lib/api';
    import BottomBar from '../components/BottomBar';

    export default {
        data() {
            return {
                list:[]
            }
        },
        computed: {
            minHeight(){
                return Store.state.minHeight;
            }
        },
        methods: {
            async init(){

            }
        },
        components: {
            BottomBar,
        },
        mounted() {
            this.init();
        }
    }
</script>


// WEBPACK FOOTER //
// profile-edit.vue?f51f735a